module.exports = __webpack_public_path__ + "static/media/MoreApps.60a99623.svg";